namespace('IO.Views.Components', function (exports) {
  var filtersMap = {
    length: LENGTH_FILTER,
    // 'class': '' TBD in future
  };

  // FILTERS
  var LENGTH_FILTER = function (length) {
    var isEmpty = length === 0,
      hasOne = length === 1,
      hasMany = length > 1;

    if (isEmpty) {
      this.$el.find(this.options.BASE_SELECTOR).toggle(hasMany);
    } else {
      this.$el.find(this.options.MANY_SELECTOR).toggle(hasMany);
      this.$el.find(this.options.ONE_SELECTOR).toggle(hasOne);
    }
  };

  // CONSTRUCTOR
  var ActionsDropdown = function () {
    this.optio;
  };

  ActionsDropdown.prototype.filter = function (key) {
    var filter = filtersMap[this.filterBy];

    filter.call(this, key);
  };

  // TBD IN THE FUTURE
  ActionsDropdown.prototype.onlyBase = function () {
    throw new Error('To be implemented in the future');
  };

  ActionsDropdown.prototype.hideAll = function () {
    throw new Error('To be implemented in the future');
  };

  exports.ActionsDropdown = ActionsDropdown;
});
